// ======================================================================
// File Name       : LiveReservedList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Table, Button, Col, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import TableHead from '../../components/TableHead';
import { parseDateForDetail } from '../../utils/index';
import ReduxFormPaging from '../../components/ReduxFormPaging';
import { RECEIVE_MESSAGE_THREAD_DETAIL } from '../../constants/PathConstants';
import PaginationCustom from '../../components/Pagination';
import {
  convertLiveFormatType,
  convertLiveRecordingPermission,
} from '../../utils/UsageSettingLiveUtils';
import { LIVE_RESERVED_DETAIL } from '../../constants/PathConstants';
import CustomLink from '../button/CustomLink';
import * as ICON from '../../constants/IconConstants';

const thead = [
  { title: 'ライブ管理ID', sortBy: 0, width: '25%' },
  { title: 'ライブ名', sortBy: 1 },
  { title: 'ライブ開催者', sortBy: null },
  { title: '形式', sortBy: 4, width: '10%' },
  { title: '開始日時', sortBy: 2},
  { title: '招待人数', sortBy: null, width: '7%' },
  { title: '操作', sortBy: null, width: 100 },
];

class LiveReservedList extends React.Component {
  render() {
    const { liveReserves, invalid, handleSortState, goToDetail, recordNum, getStartEndData, handleMouseEnter, handleMouseLeave} = this.props;
    let tbody = null;
    if (liveReserves && liveReserves.allSecernIds && liveReserves.allSecernIds.length) {
      const bySecernIds = liveReserves.bySecernIds;
      tbody = liveReserves.allSecernIds.map((liveSecernId, index) => {
        if (!bySecernIds[liveSecernId]) {
          return null;
        }
        const {
          liveName,
          organizerName,
          liveFormat,
          liveStartFrom,
          invitedUserCount,
        } = bySecernIds[liveSecernId];
        const link = LIVE_RESERVED_DETAIL.replace(':id', liveSecernId);
        return (
          <tr key={index} onMouseEnter={() => handleMouseEnter(index)} onMouseLeave={() => handleMouseLeave()}>
            <td>{liveSecernId}</td>
            <td>{liveName}</td>
            <td>{organizerName}</td>
            <td>{convertLiveFormatType(liveFormat)}</td>
            <td style={{ wordBreak: 'break-word' }}>{parseDateForDetail(liveStartFrom, 'YYYY/MM/DD HH:mm')}</td>
            <td className="text-right">{invitedUserCount}</td>
            <td className="text-center">
              <CustomLink
              className="margin-right-7 link-detail-edit"
              to={link}
              text="詳細"
            />
            </td>
          </tr>
        );
      });
    }
    return (
      <div>
        <Table striped hover>
          <thead>
            <ReduxFormPaging
              type="tableHead"
              data={thead}
              name="liveSortType"
              invalid={invalid}
              handleSortState={handleSortState}
            />
          </thead>
          <tbody>{tbody}</tbody>
        </Table>
          <Col sm={12} className="text-center">
            <ReduxFormPaging
              type="paging"
              name="startPosition"
              recordNum={recordNum}
              getStartEndData={getStartEndData}
            />
          </Col>
      </div>
    );
  }
}

export default LiveReservedList;
